/**
 * DataFilesReportsPage — Reports for all master data files:
 *   Categories, Currencies, Delivery Points, Document Types,
 *   Invoice Points, Items, Suppliers, Terms, Group Items, Customers.
 */
import React from 'react';
import AppShell from '../components/layout/AppShell';
import ModuleReports from './Reports/ModuleReports';
import { DATA_FILES_REPORTS } from './Reports/reportConfigs';

export default function DataFilesReportsPage() {
  return (
    <AppShell>
      <ModuleReports
        reports={DATA_FILES_REPORTS}
        apiPrefix="/api/module-reports/data"
        moduleLabel="Data Files"
      />
    </AppShell>
  );
}
